module.exports = __webpack_public_path__ + "img/tjx_6.6a683859.png";